import api from './api';
import { getVisitorId } from './cart';

/**
 * Track every WhatsApp click for Smart Customer Intelligence predictions
 */
export const trackInquiry = async ({ productSku, productCategory, inquiryType = 'product' }) => {
  try {
    await api.post('/inquiries', {
      visitor_id: getVisitorId(),
      product_sku: productSku || null,
      product_category: productCategory || null,
      inquiry_type: inquiryType
    });
  } catch (error) {
    console.error('Inquiry tracking failed:', error);
  }
};

/**
 * Opens WhatsApp + logs the inquiry
 */
export const openWhatsAppInquiry = ({ productSku, productCategory, productTitle, message, inquiryType = 'product' }) => {
  trackInquiry({ productSku, productCategory, inquiryType });
  
  let text = message;
  if (!text) {
    if (productSku && productTitle) {
      text = `Hi, I'm interested in ${productTitle} (${productSku}) from AHMEDABAD NX. Please share details.`;
    } else {
      text = "Hi, I would like to know more about your collections.";
    }
  }
  
  window.open(`https://wa.me/917760591999?text=${encodeURIComponent(text)}`, '_blank');
};
